<template>
  <svg width="26" height="26" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M18.6388 13.9964L10.9034 18.9724C10.3638 19.3846 9.59822 19.2732 9.19349 18.7236C9.03493 18.5082 8.94922 18.2463 8.94922 17.9772V8.02524C8.94922 7.3382 9.49605 6.78125 10.1706 6.78125C10.4349 6.78125 10.692 6.86855 10.9034 7.03005L18.6388 12.006C19.1784 12.4182 19.2878 13.198 18.8831 13.7476C18.8136 13.8419 18.7314 13.9257 18.6388 13.9964Z" fill="currentColor" />
    <path d="M25.5 13C25.5 19.9036 19.9036 25.5 13 25.5C6.09644 25.5 0.5 19.9036 0.5 13C0.5 6.09644 6.09644 0.5 13 0.5C19.9036 0.5 25.5 6.09644 25.5 13Z" stroke="currentColor" />
  </svg>
</template>

<script>
export default {
  name: 'PlayOutlinedFilled',
};
</script>
